import styled from 'styled-components'

export const Anchor = styled.div`
	position: relative;
	transform: scale(1);
	z-index: 4;
`
